import { Radio } from "antd";
import styled, { css } from "styled-components";

export const StyledUMPointCard = styled.div<{
    hasDuty?: boolean;
    isDisabled?: boolean;
    isSelected?: boolean;
}>`
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 16px 8px;
    gap: 8px;
    border-left: 5px solid
        ${({ hasDuty, isDisabled, isSelected, theme }) => {
            switch (true) {
                case isDisabled: {
                    return theme.disabledTypographyColor;
                }
                case isSelected: {
                    return theme.colors.green;
                }
                case hasDuty: {
                    return theme.dangerTypographyColor;
                }
                default:
                    return "transparent";
            }
        }};
    border-bottom: 1px solid ${(props) => props.theme.secondaryBorderColor};
    background-color: ${({ isSelected, isDisabled, theme }) => {
        switch (true) {
            case isDisabled: {
                return theme.secondaryBackgroundColor;
            }
            case isSelected: {
                return theme.itemBackground;
            }
            default:
                return "transparent";
        }
    }};
    transition: all 0.2s ease;
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
    opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};

    ${({ isSelected, theme }) =>
        isSelected &&
        css`
            border-right: 3px solid ${theme.colors.green};
            box-shadow: inset 0 0 0 1px ${theme.colors.green};
        `}
`;

export const StyledUMPointInfo = styled.div<{ isDisabled: boolean }>`
    display: flex;
    flex-direction: column;
    flex: 1;
    article {
        ${({ isDisabled, theme }) =>
            isDisabled && `color: ${theme.disabledTypographyColor} !important`};
    }
`;

export const StyledUMSelectionBadge = styled.div`
    position: absolute;
    top: 8px;
    right: 8px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background-color: ${(props) => props.theme.colors.green};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${(props) => props.theme.colors.white};
    font-size: 16px;
    box-shadow: 0 2px 8px ${(props) => props.theme.colors.green};
    z-index: 1;

    svg {
        fill: ${(props) => props.theme.colors.white};
    }
`;

export const StyledUMRadioGroup = styled(Radio.Group)`
    margin-inline: auto;

    .ant-radio-button-wrapper {
        padding-inline: 11px;
    }
`;

export const StyledUMEmptyPointGif = styled.img`
    margin-top: 20px;
    margin-bottom: 20px;
    width: 80%;
`;
